module.exports = __webpack_public_path__ + "media/src/application/media/logo-df43c207b8b1399076bbec80d6f16578.svg";